import React from 'react';
export const CancellationPolicy = () => {
  return <div className="bg-white" data-id="element-201">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-202">
        <div className="text-center" data-id="element-203">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-204">
            Cancellation Policy
          </h1>
          <p className="mt-4 text-xl text-gray-500 max-w-3xl mx-auto" data-id="element-205">
            Information about cancelling your Suretask service plan.
          </p>
        </div>
        <div className="mt-12 max-w-4xl mx-auto" data-id="element-206">
          <div className="prose prose-rose max-w-none" data-id="element-207">
            <h2 data-id="element-208">Cancellation Policy & Exclusions</h2>
            <p data-id="element-209">
              At Suretask, your satisfaction with our service plans is our
              priority. We understand that circumstances can change, so we offer
              a simple and transparent cancellation process to give you peace of
              mind.
            </p>
            <h3 data-id="element-210">Cancellation Within 14 Days</h3>
            <p data-id="element-211">
              You have the right to cancel your service plan within 14 days of
              purchase. If you cancel within this period, you'll receive a full
              refund—no questions asked. This cooling-off period lets you review
              your plan to ensure it meets your needs.
            </p>
            <h3 data-id="element-212">Cancellation After 14 Days and Within 28 Days</h3>
            <p data-id="element-213">
              If you decide to cancel after the initial 14-day period but within
              28 days from purchase, you may be eligible for a partial refund.
              This refund is granted at Suretask's discretion, considering any
              services or repairs already provided under your plan.
            </p>
            <h3 data-id="element-214">No Cancellations or Refunds After 28 Days</h3>
            <p data-id="element-215">
              Cancellations and refunds cannot be processed after 28 days from
              the purchase date. Please review your plan carefully and contact
              us promptly if you have any concerns or need assistance.
            </p>
            <h3 data-id="element-216">How to Cancel Your Service Plan</h3>
            <p data-id="element-217">
              To cancel your plan, please contact our customer support team
              using the following:
            </p>
            <ul data-id="element-218">
              <li data-id="element-219">Phone: 0800 055 4969</li>
              <li data-id="element-220">Email: manishkisan879@gmail.com</li>
            </ul>
            <p data-id="element-221">
              Once we receive your cancellation request, we'll review your case
              promptly. If eligible, your refund will be processed quickly, and
              you'll receive confirmation when your cancellation and refund are
              complete.
            </p>
            <h3 data-id="element-222">Refund Processing</h3>
            <p data-id="element-223">
              All refunds are made to the original payment method used at
              purchase. For security reasons, we don't process refunds to
              alternative accounts or payment methods.
            </p>
            <h3 data-id="element-224">Plan Exclusions and Coverage Limits</h3>
            <p data-id="element-225">
              To maintain fairness and service quality, the following are
              excluded from coverage under your Suretask plan:
            </p>
            <ul data-id="element-226">
              <li data-id="element-227">
                <strong data-id="element-228">Pre-existing Faults:</strong> Faults or damage present
                before your plan started are not covered.
              </li>
              <li data-id="element-229">
                <strong data-id="element-230">Misuse or Neglect:</strong> Damage caused by improper
                use, neglect, accidents, or unauthorized repairs is excluded.
              </li>
              <li data-id="element-231">
                <strong data-id="element-232">Non-standard Repairs:</strong> Repairs beyond normal
                appliance operation or servicing, including modifications or
                alterations, are excluded.
              </li>
              <li data-id="element-233">
                <strong data-id="element-234">Illegal or Fraudulent Use:</strong> Any fraudulent or
                illegal use of our services will result in immediate plan
                cancellation without refund.
              </li>
              <li data-id="element-235">
                <strong data-id="element-236">Manufacturer's Guidelines:</strong> Appliances not used
                or maintained as per manufacturer instructions are excluded.
              </li>
            </ul>
            <p data-id="element-237">
              If any of these exclusions apply, your plan may be voided
              immediately, and you'll lose eligibility for repairs or refunds
              under the plan.
            </p>
            <h3 data-id="element-238">Need Help?</h3>
            <p data-id="element-239">
              If you have any questions about cancelling your plan or want
              clarification on coverage, please contact our customer service
              team. We're here to support you and ensure you understand your
              options clearly.
            </p>
          </div>
        </div>
      </div>
    </div>;
};